import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Formatiert ein Datum (ISO String oder Date) als DD.MM.YYYY.
 * Akzeptiert "2026-07-15", "2026-07-15T10:30:00Z" oder Date-Objekt.
 * Gibt leeren String zurück bei ungültigem/leerem Input.
 */
export function formatDateDE(value) {
  if (!value) return "";
  const s = typeof value === "string" ? value : value.toISOString?.() || "";
  // Match ISO date YYYY-MM-DD at the start
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  // Fallback: try Date parsing
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}.${mm}.${d.getFullYear()}`;
}

/** Kompakter Zeitraum für Rechnungen: "21.–24.09.2026" / "28.09.–02.10.2026". */
export function dateRangeDE(from, to) {
  if (!from) return "";
  if (!to || from === to) return formatDateDE(from);
  const a = String(from).match(/^(\d{4})-(\d{2})-(\d{2})/);
  const b = String(to).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!a || !b) return `${formatDateDE(from)} – ${formatDateDE(to)}`;
  if (a[1] === b[1] && a[2] === b[2]) return `${a[3]}.–${b[3]}.${a[2]}.${a[1]}`;
  if (a[1] === b[1]) return `${a[3]}.${a[2]}.–${b[3]}.${b[2]}.${a[1]}`;
  return `${formatDateDE(from)} – ${formatDateDE(to)}`;
}


// ---------- Werktag / Wochenende & Feiertag ----------
function easterSunday(year) {
  const a = year % 19, b = Math.floor(year / 100), c = year % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(year, month - 1, day));
}

const toYMDUTC = (d) => d.toISOString().slice(0, 10);

// Bundesweite deutsche Feiertage (regionale markiert der Admin manuell)
export function germanHolidays(year) {
  const easter = easterSunday(year);
  const days = [
    `${year}-01-01`, `${year}-05-01`, `${year}-10-03`, `${year}-12-25`, `${year}-12-26`,
  ];
  for (const off of [-2, 1, 39, 50]) {
    const d = new Date(easter.getTime() + off * 86400000);
    days.push(toYMDUTC(d));
  }
  return new Set(days);
}

export function isWeekendOrHoliday(dateStr) {
  const m = (dateStr || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return false;
  const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  const dow = d.getUTCDay();
  return dow === 0 || dow === 6 || germanHolidays(Number(m[1])).has(dateStr.slice(0, 10));
}

// Aufeinanderfolgende Einsatztage ab Startdatum (YYYY-MM-DD)
export function bookingDates(startDateStr, days) {
  const m = (startDateStr || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return [];
  const start = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  const n = Math.max(1, Number(days) || 1);
  return Array.from({ length: n }, (_, i) => toYMDUTC(new Date(start.getTime() + i * 86400000)));
}


// Heutiges Datum in deutscher Ortszeit als YYYY-MM-DD.
// Wichtig: `new Date().toISOString()` liefert UTC — zwischen 00:00 und 02:00
// Ortszeit wäre das der Vortag.
export function toYMDLocal(d = new Date()) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
